import React from 'react';
import {Outlet} from 'react-router-dom';

const CommonPageLayout = () => {
    return (
        <><Outlet/></>
    );
};

export default CommonPageLayout;
